import AddCircleIcon from "@mui/icons-material/AddCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Paper, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import {
    checkedListEmptyMsg,
    checkMandatoryFieldsInTableMsg,
    noInternetMsg,
    saveFailedMsg,
    savemsg,
    saveWarningMsg,
    serverMsg,
    updateData,
    updateFailed,
    updateMsg
} from "../../../config/messageconstant";
import { AllowanceWiseClaimUpdateJson } from "../../../DynamicFormsJson/MastersJSON/allowanceWiseClaimUpdate";

import { showLoador, showNotification } from "../../Landing/Landing.slice";
import endpoint from "../../../config/endpoints";
import { apiGet, apiPost } from "../../../utils/api_service";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import { getAllowanceWiseClaimApplyByDate, setAllowanceWiseClaimApplyByDate } from "../../../Slice/claim.slice";
import { ButtonCompo } from "../../../components/Comman/Button";

class AllowanceWiseClaimUpdate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
            },
            addClaimPopUpFlag: false,
            claimDetailsPopUpFlag: false,
            claimDetailsData: {},
            addClaimData: {},
            searchValue: "",
            onSearchDataObj: {},
            allChecked: false,
            isError: false,
            detailList: [],
        };

        this.tableStyles = {
            tabContainer: {
                display: "flex",
                marginBottom: "16px",
                borderBottom: "1px solid #E5F1F9",
            },

            inputBoxStyle: {
                width: "90px",
                padding: "4px 8px",
                borderRadius: "4px",
                border: "1px solid #cfd8dc",
                fontSize: "15px",
                outline: "none",
                background: "#f9f9fb"
            },

            errorStyle: {
                color: "#e53935",
                fontSize: "12px",
                marginTop: "2px"
            },

            tableWrapper: {
                maxHeight: "570px",
                overflowY: "auto",
                overflowX: "auto", // Enable horizontal scrolling
                width: "100%",
                border: "1px solid rgb(182, 186, 188)",
                borderRadius: "8px",
                marginTop: "5px",
            },

            table: {
                minWidth: "1400px", // Set minimum width to ensure horizontal scroll when needed
                width: "auto", // Auto width instead of 100%
                borderCollapse: "collapse",
                tableLayout: "auto", // Auto layout for flexible column sizing
            },

            stickyHeader: {
                position: "sticky",
                top: 0,
                backgroundColor: "rgb(233, 240, 243)",
                zIndex: 10,
            },

            tab: {
                padding: "8px 16px",
                cursor: "pointer",
                color: "#333",
                fontSize: "14px",
                fontWeight: "500",
                transition: "color 0.2s ease-in-out",
            },

            activeTab: {
                color: "#1C4E80",
                borderBottom: "2px solid #1C4E80",
            },

            noData: {
                padding: "16px",
                textAlign: "center",
                fontSize: "14px",
                color: "#666",
            },

            tableContainer: {
                backgroundColor: "#fff",
                borderRadius: "10px",
                padding: "16px",
                width: "100%",
                margin: "0 auto",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            },

            searchContainer: {
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                maxWidth: "300px",
            },

            headerRow: {
                backgroundColor: "rgb(233, 240, 243)",
                color: "#000",
                fontWeight: "bold",
                fontSize: "14px",
            },

            headerCell: {
                padding: "12px 8px",
                textAlign: "center",
                borderBottom: "2px solid #E5F1F9",
                borderRight: "1px solid #E5F1F9",
                fontWeight: 600,
                whiteSpace: "nowrap",
                position: "sticky",
                top: 0,
                backgroundColor: "rgb(233, 240, 243)",
                // Removed fixed width, using minWidth instead
            },

            dataRow: {
                backgroundColor: "#fff",
                transition: "background-color 0.2s ease-in-out",
            },

            dataRowHover: {
                backgroundColor: "#E5F1F9",
            },

            dataCell: {
                padding: "12px 8px",
                fontSize: "13px",
                color: "#333",
                borderBottom: "1px solid #E5F1F9",
                borderRight: "1px solid #E5F1F9",
                verticalAlign: "top", // Better alignment for wrapped content
                // Removed fixed width, using minWidth instead
            },

            // New style for cell content with proper wrapping
            cellContent: {
                wordWrap: "break-word",
                wordBreak: "break-word",
                whiteSpace: "normal", // Allow text wrapping
                lineHeight: "1.4",
                maxWidth: "100%",
            },

            amountCell: {
                color: "#004969",
                fontWeight: "500",
                fontSize: "13px",
            },

            alternateRow: {
                backgroundColor: "#fff",
            },

            searchInput: {
                width: "100%",
                padding: "8px 12px",
                fontSize: "14px",
                border: "1px solid #E5F1F9",
                borderRadius: "6px",
                outline: "none",
                color: "#333",
                transition: "border-color 0.3s ease-in-out",
            },

            searchInputFocus: {
                borderColor: "#1C4E80",
                boxShadow: "0 0 5px rgba(28, 78, 128, 0.3)",
            },
        };
    }
    async componentDidMount() {
        const { showNotification, showLoador, setAllowanceWiseClaimApplyByDate } = this.props;
        if (navigator.onLine) {

            setAllowanceWiseClaimApplyByDate({ row: [] });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }

    }


    onSearch = (data) => {
        const { showLoador, showNotification, getAllowanceWiseClaimApplyByDate } = this.props;

        if (navigator.onLine) {

            this.setState({ onSearchDataObj: data });

            showLoador({ loador: true });
            getAllowanceWiseClaimApplyByDate({ fromDate: data.fromDate, toDate: data.toDate })
                .then(({ response, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        showNotification({ msg: serverMsg, severity: "error" });
                    } else {
                        const detailsData = response.flatMap((headerObj) =>
                            headerObj.claimApplyDetail.map((detailObj) => ({
                                id: detailObj.id === null ? "" : detailObj.id,
                                remark: detailObj.remark === null ? "" : detailObj.remark,
                                headerId: headerObj.id === null ? "" : headerObj.id,
                                headerDate:
                                    headerObj.date === null ? "" : headerObj.date,
                                headerDay:
                                    headerObj.dayName === null ? "" : headerObj.dayName,
                                headerSalesTeamEmployeeCode:
                                    headerObj.salesTeamEmployeeCode === null ? "" : headerObj.salesTeamEmployeeCode,
                                headerSalesTeamName:
                                    headerObj.salesTeamName === null ? "" : headerObj.salesTeamName,
                                headerStockStakeHolderTypeName:
                                    headerObj.stockStakeHolderTypeName === null ? "" : headerObj.stockStakeHolderTypeName,
                                headerAuthoritySalesPersonName:
                                    headerObj.authoritySalesPersonName === null ? "" : headerObj.authoritySalesPersonName,
                                headerAuthoritySalesPersonTypeName:
                                    headerObj.authoritySalesPersonTypeName === null ? "" : headerObj.authoritySalesPersonTypeName,
                                headerClaimTitle:
                                    headerObj.name === null ? "" : headerObj.name,
                                claimApplyHeaderId: detailObj.claimApplyHeaderId === null ? "" : detailObj.claimApplyHeaderId,
                                claimTypeName: detailObj.claimTypeName === null ? "" : detailObj.claimTypeName,
                                claimType: detailObj.claimType === null ? "" : detailObj.claimType,
                                claimAmt: detailObj.claimAmt === null ? "" : detailObj.claimAmt,
                                headerClaimAmt:
                                    headerObj.claimAmt === null ? "" : headerObj.claimAmt,
                                headerStatus: headerObj.claimStatus === null ? "" : headerObj.claimStatus,
                                isChecked: false,
                                isError: false,
                            }))
                        );
                        console.debug(detailsData);
                        this.setState({ detailList: detailsData });
                    }
                });

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }

    }


    handleCloses = () => {
        this.setState({ addClaimPopUpFlag: false, claimDetailsPopUpFlag: false })
    }


    onSubmitData = () => {
        const { showLoador, showNotification } = this.props;
        const { addClaimData, onSearchDataObj } = this.state;
        swal({
            title: "Are you sure?",
            text: saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiPost({
                    url: endpoint.claimApplyHeader + "/save-on-click-for-sales-team?date="
                        + addClaimData.date + "&isDayEndClaim=0&salesTeamId=" + addClaimData.salesTeamId,
                    postBody: addClaimData.beatWorkInfo,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (success) {
                        if (data.data.statusCode == 500) {
                            showNotification({ msg: data.data.message, severity: "error", });
                        } else {
                            showNotification({ msg: data.data.message });
                            this.onSearch(onSearchDataObj);
                            this.setState({ addClaimPopUpFlag: false });
                        }
                    } else {
                        showNotification({
                            msg: saveFailedMsg,
                            severity: "error",
                        });
                    }
                });
            }
        });
    }

    onSearchBox = (searchValue) => {
        this.setState({
            searchValue: searchValue,
        });
    };

    getFilteredTableData = (searchData) => {
        const { searchValue } = this.state;
        return searchData.filter((currentRow) => {
            let isValid = false;
            if (
                (currentRow["headerDate"] &&
                    currentRow["headerDate"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerSalesTeamEmployeeCode"] &&
                    currentRow["headerSalesTeamEmployeeCode"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerSalesTeamName"] &&
                    currentRow["headerSalesTeamName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerStockStakeHolderTypeName"] &&
                    currentRow["headerStockStakeHolderTypeName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerAuthoritySalesPersonName"] &&
                    currentRow["headerAuthoritySalesPersonName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerAuthoritySalesPersonTypeName"] &&
                    currentRow["headerAuthoritySalesPersonTypeName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerClaimTitle"] &&
                    currentRow["headerClaimTitle"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["claimTypeName"] &&
                    currentRow["claimTypeName"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["claimAmt"] &&
                    currentRow["claimAmt"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase())) ||
                (currentRow["headerStatus"] &&
                    currentRow["headerStatus"]
                        .toString()
                        .toLowerCase()
                        .includes(searchValue.trim().toLowerCase()))

            ) {
                isValid = true;
                return true;
            }
        });
    };


    handleAllCheckedClick = (e) => {
        const { claimList, setAllowanceWiseClaimApplyByDate } = this.props;
        const { detailList } = this.state;
        this.setState({ allChecked: e.target.checked });
        let dataList = detailList.map((dataObj) => {
            return {
                ...dataObj,
                isChecked: e.target.checked,
            };
        });
        this.setState({ detailList: dataList });
    };

    handleClick = (e, id) => {
        const { detailList } = this.state;

        let data = detailList.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    isChecked: e.target.checked,
                };
            } else {
                return dataObj;
            }
        });
        this.setState({ detailList: data });
    };


    changeHandler = (row) => (e) => {
        const { name, value, placeholder } = e.target;
        const { detailList } = this.state;

        let updatedList = detailList.map((dataObj) => {
            if (dataObj.id === row.id) {
                return {
                    ...dataObj,
                    [name]: value,
                    [`${name}Error`]:
                        value.trim() === "" ? placeholder + " cannot be empty" : "",
                    isError: value.trim() === "",
                };
            } else {
                return dataObj;
            }
        });

        console.log("updatedList-", updatedList);

        this.setState({ detailList: updatedList });
    };


    validateRow = (row) => {
        let errors = {};

        if (!row.claimAmt || row.claimAmt.toString().trim() === "") {
            errors.claimAmtError = "Amount is required.";
        }
        return errors;
    };

    onSubmit = () => {
        const { showLoador, showNotification } = this.props;
        const { detailList } = this.state;
        let filterClaimDetailsList = [];
        let hasError = false;

        detailList.length != 0 &&
            detailList.map((detailObj) => {
                if (detailObj.isChecked) {
                    if (detailObj.isError) {
                        hasError = true;
                    }

                    const claimDetailListToSave = {
                        claimApplyDetailId: detailObj.id,
                        claimAmt: detailObj.claimAmt,
                    };
                    filterClaimDetailsList.push(claimDetailListToSave);
                }
            });


        console.log(filterClaimDetailsList);

        if (filterClaimDetailsList.length !== 0) {
            if (!hasError) {
                swal({
                    title: "Are you sure?",
                    text: updateData,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then((willDelete) => {
                    if (willDelete) {
                        showLoador({ loador: true });
                        apiPost({
                            url: endpoint.claimApplyHeader + "/update-claim-apply-header-detail-ta-da-edited-amt",
                            postBody: filterClaimDetailsList,
                        }).then(({ success }) => {
                            showLoador({ loador: false });
                            if (success) {
                                showNotification({
                                    msg: updateMsg,
                                });
                                window.location.reload();
                            } else {
                                showNotification({
                                    msg: updateFailed,
                                    severity: "error",
                                });
                            }
                        });
                    }
                });
            } else {
                showNotification({ msg: checkMandatoryFieldsInTableMsg, severity: "error" });
            }
        } else {
            showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }
    };



    render() {
        const { claimList } = this.props;
        const {
            dynamicMasterData,
            addClaimPopUpFlag,
            addClaimData,
            claimDetailsData,
            claimDetailsPopUpFlag,
            allChecked,
            detailList,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutSave
                        dynamicMasterData={dynamicMasterData}
                        searchList={AllowanceWiseClaimUpdateJson.searchList}
                        showSaveBtn={true}
                        showSaveBtnMain={false}
                        showTitle={AllowanceWiseClaimUpdateJson.showTitle}
                        screenTitle={AllowanceWiseClaimUpdateJson.screenTitle}
                        fieldMeta={AllowanceWiseClaimUpdateJson.fieldMeta}
                        showCancel={AllowanceWiseClaimUpdateJson.showCancel}
                        apiBaseURL={AllowanceWiseClaimUpdateJson.apiBaseURL}
                        showSaveNextBtn={AllowanceWiseClaimUpdateJson.showSaveNextBtn}
                        saveBtnText={"Search"}
                        onSave={this.onSearch}
                    />
                    <br />
                    {detailList.length !== 0 && (
                        <>
                            <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                onSearch={this.onSearchBox}
                            />
                            <div style={this.tableStyles.tableWrapper}>
                                <table style={this.tableStyles.table}>
                                    <thead style={this.tableStyles.stickyHeader}>
                                        <tr style={this.tableStyles.headerRow}>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "50px" }}>
                                                <input
                                                    type="checkbox"
                                                    style={{ transform: "scale(1.5)", margin: "0 8px" }}
                                                    checked={allChecked}
                                                    onChange={this.handleAllCheckedClick} />
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "60px" }}>
                                                Sr.No
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "100px", textAlign: "center" }}>
                                                Date
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "100px", textAlign: "center" }}>
                                                Emp Code
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "150px", textAlign: "left" }}>
                                                Sales Team
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "160px", textAlign: "left" }}>
                                                Sales Team Type
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "180px", textAlign: "left" }}>
                                                Authority Person
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "180px", textAlign: "left" }}>
                                                Authority Person Type
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "150px", textAlign: "left" }}>
                                                Claim Title
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "100px", textAlign: "center" }}>
                                                Claim Type
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "120px", textAlign: "center" }}>
                                                Amount
                                            </th>
                                            <th style={{ ...this.tableStyles.headerCell, minWidth: "80px", textAlign: "center" }}>
                                                Status
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {detailList.length !== 0 &&
                                            this.getFilteredTableData(detailList).map((row, index) => {
                                                return (
                                                    <tr
                                                        key={index + 1}
                                                        style={{
                                                            ...this.tableStyles.dataRow,
                                                            ...this.tableStyles.alternateRow,
                                                            ...(index % 2 === 0 ? this.tableStyles.alternateRow : {}),
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                                this.tableStyles.dataRowHover.backgroundColor;
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.backgroundColor =
                                                                row.flag == 1
                                                                    ? "#ed8e98"
                                                                    : index % 2 === 0
                                                                        ? this.tableStyles.alternateRow.backgroundColor
                                                                        : this.tableStyles.dataRow.backgroundColor;
                                                        }}
                                                    >
                                                        <td style={{ ...this.tableStyles.dataCell, textAlign: "center", minWidth: "50px" }}>
                                                            <input
                                                                type="checkbox"
                                                                style={{ transform: "scale(1.5)", margin: "0 8px" }}
                                                                checked={row.isChecked}
                                                                onChange={e => this.handleClick(e, row.id)}
                                                            />
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "60px", textAlign: "center" }}>
                                                            {index + 1}
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "100px", textAlign: "center" }}>
                                                            {row.headerDate}
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "100px", textAlign: "center" }}>
                                                            {row.headerSalesTeamEmployeeCode}
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "150px", textAlign: "left" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.headerSalesTeamName}
                                                            </div>
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "160px", textAlign: "left" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.headerStockStakeHolderTypeName}
                                                            </div>
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "180px", textAlign: "left" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.headerAuthoritySalesPersonName}
                                                            </div>
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "180px", textAlign: "left" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.headerAuthoritySalesPersonTypeName}
                                                            </div>
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "150px", textAlign: "left" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.headerClaimTitle}
                                                            </div>
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "100px", textAlign: "left" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.claimTypeName}
                                                            </div>
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "120px", textAlign: "right" }}>
                                                            <input
                                                                type="number"
                                                                name="claimAmt"
                                                                value={row.claimAmt}
                                                                onChange={this.changeHandler(row)}
                                                                placeholder="Amount"
                                                                style={this.tableStyles.inputBoxStyle}
                                                            />
                                                            {row.claimAmtError && (
                                                                <div style={this.tableStyles.errorStyle}>{row.claimAmtError}</div>
                                                            )}
                                                        </td>
                                                        <td style={{ ...this.tableStyles.dataCell, minWidth: "80px", textAlign: "center" }}>
                                                            <div style={this.tableStyles.cellContent}>
                                                                {row.headerStatus}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>

                            <br />
                            <Grid
                                item
                                sm={12}
                                xs={12}
                                md={12}
                                lg={12}
                                rowSpacing={2}
                                columnSpacing={{ xs: 12, sm: 6, md: 1 }}
                                container
                                justifyContent="right"
                            >
                                <ButtonCompo
                                    size="medium"
                                    type="submit"
                                    variant="contained"
                                    name="Update"
                                    onClick={this.onSubmit}
                                />
                            </Grid>

                        </>

                    )}


                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    claimList: state.claim
});
const mapDispatchToProps = {
    showNotification,
    getAllowanceWiseClaimApplyByDate,
    showLoador,
    setAllowanceWiseClaimApplyByDate,
};
export default connect(mapStateToProps, mapDispatchToProps)(AllowanceWiseClaimUpdate);
